import ChannelIcon from "../../components/ChannelIcon.js";
import {CHANNEL_SORT_PRIORITY} from "../../enums/channel.js";
import {request} from "../../utils/request/index.js";
import {useRequest} from "../../../__snowpack__/pkg/ahooks.js";
import {Space} from "../../../__snowpack__/pkg/antd.js";
import React from "../../../__snowpack__/pkg/react.js";
export default function useQueryShops(params = {}, options) {
  const result = useRequest((_params) => request.post("/saas/shop/list", {
    page: 0,
    size: 1e3,
    ..._params,
    ...params
  }), options);
  const {content: _shops = []} = result?.data ?? {};
  const shops = _shops.sort((a, b) => {
    return (CHANNEL_SORT_PRIORITY[a.channelId] ?? -1) - (CHANNEL_SORT_PRIORITY[b.channelId] ?? -1);
  });
  const _options = shops.map((shop) => ({
    ...shop,
    label: /* @__PURE__ */ React.createElement(Space, {
      align: "center"
    }, /* @__PURE__ */ React.createElement(ChannelIcon, {
      channelId: shop.channelId
    }), /* @__PURE__ */ React.createElement("span", null, "(", shop?.countryCode, ")"), /* @__PURE__ */ React.createElement("span", null, shop.shopName)),
    value: shop.id
  }));
  const tagsOptions = shops.map((shop) => ({
    text: /* @__PURE__ */ React.createElement(Space, {
      align: "center",
      size: 4
    }, /* @__PURE__ */ React.createElement(ChannelIcon, {
      channelId: shop.channelId
    }), /* @__PURE__ */ React.createElement("span", null, "(", shop?.countryCode, ")"), /* @__PURE__ */ React.createElement("span", null, shop.shopName)),
    key: shop.id,
    channelId: shop.channelId
  }));
  const channelOptions = shops.reduce((acc, obj) => {
    const isExist = acc.some((shopItem) => shopItem?.key === obj?.channelId);
    if (!isExist) {
      acc.push({
        key: obj?.channelId,
        text: obj?.channelName
      });
    }
    return acc;
  }, []);
  return {...result, shops, options: _options, tagsOptions, channelOptions};
}
